import Typography from 'apollo-react/components/Typography';
import React from 'react';

import LazyText from '../../components/LazyText';
import { getUITA } from '../../utils/commonUtils';

function SSGridColumn({ label, entityName, fieldName }) {
  return (
    <LazyText text={label}>
      <Typography
        ui-ta={getUITA('FormPart', 'SSGridColumn', entityName, fieldName)}
        variant="body2"
      >
        {label}
      </Typography>
    </LazyText>
  );
}

export default SSGridColumn;
